import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Field, inputClass } from './BackgroundFields';
import { uid } from '../utils/defaults';
import MenuTabEntryAppearanceFields from './MenuTabEntryAppearanceFields';

function MenuButtonLinkFields({ btn, sections, onPatch }) {
  const linkType = btn.linkType || 'section';
  const anchorValue = String(btn.sectionAnchor || '').replace(/^#/, '');

  return (
    <>
      <Field label="Destination">
        <select
          className={inputClass}
          value={linkType}
          onChange={(e) => onPatch({ linkType: e.target.value })}
        >
          <option value="section">Ancre — section de la page</option>
          <option value="publicPath">Page publique (commande…)</option>
          <option value="url">URL externe</option>
        </select>
      </Field>
      {linkType === 'section' ? (
        <>
          {sections.length > 0 ? (
            <Field label="Section cible">
              <select
                className={inputClass}
                value={anchorValue}
                onChange={(e) => onPatch({ sectionAnchor: e.target.value })}
              >
                <option value="">— Choisir une section —</option>
                {sections.map((s) => (
                  <option key={s.id} value={s.anchor}>
                    {s.label} (#{s.anchor})
                  </option>
                ))}
              </select>
            </Field>
          ) : null}
          <Field label="Ancre (identifiant)">
            <input
              className={inputClass}
              value={btn.sectionAnchor || ''}
              onChange={(e) =>
                onPatch({
                  sectionAnchor: String(e.target.value || '').replace(/^#/, ''),
                })
              }
              placeholder="contact"
            />
          </Field>
        </>
      ) : null}
      {linkType === 'url' ? (
        <Field label="URL">
          <input
            className={inputClass}
            value={btn.url || ''}
            onChange={(e) => onPatch({ url: e.target.value })}
            placeholder="https://…"
          />
        </Field>
      ) : null}
      {linkType === 'publicPath' ? (
        <Field label="Chemin page publique">
          <input
            className={inputClass}
            value={btn.publicPath || ''}
            onChange={(e) => onPatch({ publicPath: e.target.value })}
            placeholder="/commande"
          />
        </Field>
      ) : null}
    </>
  );
}

export default function MenuButtonsFields({
  buttons = [],
  sections = [],
  menuProps = {},
  onChange,
  onChangeTabHoverEffect,
  onChangeTabAppearance,
  onChangeTabPlacement,
}) {
  const list = buttons || [];
  const tabHoverEffects = menuProps?.tabHoverEffects || {};
  const tabAppearances = menuProps?.tabAppearances || {};
  const freeLayout = menuProps?.menuFreeLayout === true;

  const update = (next) => onChange(next);

  const addButton = () => {
    const firstAnchor = sections[0]?.anchor || '';
    update([
      ...list,
      {
        id: uid('mbtn'),
        label: 'Bouton',
        linkType: 'section',
        sectionAnchor: firstAnchor,
        url: '',
        publicPath: '',
      },
    ]);
  };

  const patchButton = (id, patch) => {
    update(list.map((b) => (b.id === id ? { ...b, ...patch } : b)));
  };

  const removeButton = (id) => {
    update(list.filter((b) => b.id !== id));
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-foreground">Boutons du menu</p>
        <Button type="button" variant="outline" size="sm" onClick={addButton}>
          <Icon name="Plus" size={14} className="mr-1" />
          Ajouter un bouton
        </Button>
      </div>

      {list.length === 0 ? (
        <p className="text-xs text-muted-foreground">
          CTA personnalisés (couleurs, forme, survol, ancre, position à droite…).
        </p>
      ) : (
        <ul className="space-y-4">
          {list.map((btn) => {
            const tabKey = `button:${btn.id}`;
            return (
              <li
                key={btn.id}
                className="rounded-lg border border-border p-3 space-y-3 bg-muted/10"
              >
                <div className="flex items-start justify-between gap-2">
                  <span className="text-xs font-medium text-foreground">Bouton menu</span>
                  <button
                    type="button"
                    className="p-1 rounded hover:bg-destructive/10 text-destructive"
                    title="Supprimer"
                    onClick={() => removeButton(btn.id)}
                  >
                    <Icon name="Trash2" size={14} />
                  </button>
                </div>
                <Field label="Libellé">
                  <input
                    className={inputClass}
                    value={btn.label || ''}
                    onChange={(e) => patchButton(btn.id, { label: e.target.value })}
                  />
                </Field>
                <MenuButtonLinkFields
                  btn={btn}
                  sections={sections}
                  onPatch={(patch) => patchButton(btn.id, patch)}
                />
                <MenuTabEntryAppearanceFields
                  tabKey={tabKey}
                  menuProps={menuProps}
                  tabHoverEffects={tabHoverEffects}
                  tabAppearances={tabAppearances}
                  onChangeTabHoverEffect={onChangeTabHoverEffect}
                  onChangeTabAppearance={onChangeTabAppearance}
                  onChangeTabPlacement={onChangeTabPlacement}
                  defaultVariant="solid"
                  freeLayout={freeLayout}
                />
              </li>
            );
          })}
        </ul>
      )}
      {list.length > 0 ? (
        <p className="text-[11px] text-muted-foreground">
          L&apos;ordre par rapport aux sections se règle dans la liste{' '}
          <strong className="font-medium text-foreground">Ordre des onglets</strong> plus bas.
        </p>
      ) : null}
    </div>
  );
}
